import type { FC } from 'react';

import { LabelledToggleStyled } from './styles/LabelledToggleStyled'
import { type IToggleProps } from './Toggle'

export interface ILabelledToggleProps extends IToggleProps {
  yesColor?: string
  noColor?: string
}

export const LabelledToggle: FC<ILabelledToggleProps> =
  LabelledToggleStyled

LabelledToggle.displayName = 'LabelledToggle'
LabelledToggle.defaultProps = {
  yes: 'Yes',
  no: 'No',
  yesColor: 'primary',
  noColor: 'danger',
}
